import React, { useContext, useEffect, useState } from "react";
import { BotContext } from "../../../context/BotContext";
import { QuestionContent } from "../QuestionContent";

const QuestionBubble = (props) => {
  const { buttonProps } = useContext(BotContext);
  const [buttonQuestion] = useState({
    questionquestion: buttonProps?.question,
    label_question: buttonProps?.label_question,
  });
  const message = props.message ?? buttonQuestion;
  useEffect(() => {
    setTimeout(() => {
      if (props.handleNewQuestion) {
        props.handleNewQuestion();
      }
    }, 100);
  }, []);

  return (
    <QuestionContent
      questionText={message?.label_question}
      createdAt={props.message?.createdAt}
    />
  );
};

export { QuestionBubble };
